import { trackClientEvent } from 'analytics/analytics'

const CATEGORY = 'experiences'
const SUBJECT = 'experience_upsell_snackbar'

/** Records that the post-purchase experience upsell snackbar was shown. */
export function trackExperienceUpsellSnackbarImpression(): void {
  trackClientEvent({
    category: CATEGORY,
    subject: SUBJECT,
    action: 'impression',
    type: 'nonInteraction',
  })
}

/** Records that the customer selected the snackbar CTA to browse experiences. */
export function trackExperienceUpsellSnackbarClick(): void {
  trackClientEvent({
    category: CATEGORY,
    subject: SUBJECT,
    action: 'click',
    type: 'interaction',
  })
}
